define(['angular', '../module'], function (angular, MODULE_NAME ) {
    'use strict';

    angular
        .module(MODULE_NAME)
        .service('PlatformDomainService', PlaformDomainService);

    PlaformDomainService.$inject = ['$http', '$log', '$location', 'ilmnUiCookieUtil'];
    function PlaformDomainService($http, $log, $location, ilmnUiCookieUtil) {

        var domainInfo;

        return {
            getCurrentDomain: getCurrentDomain,
            getDomainInfo: getDomainInfo,
            getPlatformServiceUrl: getPlatformServiceUrl
        };

        function getCurrentDomain() {
            return $location.host().split('.')[0];
        }

        function getPlatformServiceUrl(domainSpecific) {
            var psTokenIssuingAuthorities = ilmnUiCookieUtil.get('psTokenIssuingAuthorities');

            if(psTokenIssuingAuthorities) {
                var platformHost = psTokenIssuingAuthorities.replace(new RegExp('"', 'g'), '');
                if(domainSpecific) {
                    platformHost = platformHost.replace(/https:\/\//, 'https://' + getCurrentDomain() + ".");
                }
                return platformHost;
            }
        }

        function getDomainInfo(subDomain, platformDomainInfoUrl) {
            if (!domainInfo) {
                var regex = new RegExp("{domainName}", 'g');
                var url = platformDomainInfoUrl.replace(regex, subDomain);
                domainInfo = $http.get(url).then(
                    function successCallback(response) {
                        updateUrlsForApps(response.data);
                        return response.data;
                    },
                    function errorCallback(response) {
                        $log.error('There was error getting domain info: ', response);
                    }
                );
            }
            return domainInfo;
        }

        function updateUrlsForApps(domainInfo) {
            if (domainInfo.apps && domainInfo.apps.length > 0) {
                domainInfo.apps.forEach(function(app) {
                    var subDomain = domainInfo.urlPatterns && domainInfo.urlPatterns.length > 0 ? domainInfo.urlPatterns[0] : undefined;
                    if (subDomain && app.urlPattern && app.appUrl && app.appUrl.indexOf(app.urlPattern) !== -1) {
                        app.appUrl = app.appUrl.replace(app.urlPattern, subDomain);
                    }
                });
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-utils/services/platformDomain.service.js
// module id = 22
// module chunks = 0